module.exports = __webpack_public_path__ + "img/insta-12.dd162d7c.jpg";